/* eslint-disable no-unused-vars */

import * as React from "react";

import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { FormControlLabel, Grid } from "@mui/material";
import { produce } from "immer";
// eslint-disable-next-line import/no-cycle
import {
    PTMConfirmDialog, PTMDialog, PTMInput,
} from "../../Components";
import api from "../../api";
import PTMBottomAppBar from "../../Components/PTMBottomAppBar";

function HelpDialog(props) {
    const {
        isOpen, onClose, canEdit, helpInfo, tabId,
    } = props;
    const [open, setOpen] = React.useState(isOpen);
    const [editorOpen, setEditorOpen] = React.useState(false);
    const [saving, setSaving] = React.useState(false);
    const [confirmDiscard, setConfirmDiscard] = React.useState(false);
    const [helpPayload, setHelpPayload] = React.useState(helpInfo);
    const [helpPayLoadCopy, setHelpPayLoadCopy] = React.useState();

    React.useEffect(() => {
        let newHelpPayLoad = { ...helpPayload };
        newHelpPayLoad = helpInfo;
        setHelpPayload(newHelpPayLoad);
        setHelpPayLoadCopy(newHelpPayLoad);
    }, [helpInfo]);

    const changeHelpPayload = (value, field) => {
        setHelpPayload(produce(helpPayload, (draft) => {
            draft[field] = value;
        }));
    };

    const resetPayload = () => {
        let newHelpPayLoad = { ...helpPayload };
        newHelpPayLoad = helpPayLoadCopy;
        setHelpPayload(newHelpPayLoad);
    };

    const closeAndClean = () => {
        resetPayload();
        onClose();
        setTimeout(() => {
            setEditorOpen(false);
        }, 200);
    };

    const handleClose = () => {
        if (true === false) setOpen(false);
        // Check if the original content or title are modified and in case show a confirm dialog
        if (JSON.stringify(helpPayload) !== JSON.stringify(helpPayLoadCopy)) {
            setConfirmDiscard(true);
        } else {
            closeAndClean();
        }
    };
    const sendHelpPayload = async () => {
        setSaving(true);
        await api.help.save(helpPayload);
        // Actualise HelpPayLoadCopy
        let newHPCopy = { ...helpPayLoadCopy };
        const newHP = { ...helpPayload };
        newHPCopy = newHP;
        setHelpPayLoadCopy(newHPCopy);
        setTimeout(() => {
            setSaving(false);
            setTimeout(() => {
                setEditorOpen(false);
            }, 500);
        }, 200);
    };

    function editorScreen() {
        return (
            <>
                <div
                    style={{
                        padding: "10px", flex: 1, display: "flex", flexDirection: "column",
                    }}
                >
                    <Grid
                        container
                        sx={{
                            width: "100%",
                            "&>.MuiGrid-root>.MuiGrid-item": {
                                padding: 5,
                            },
                        }}
                    >
                        <Grid item>
                            <PTMInput
                                id="outlined-helperText"
                                label="Titel bearbeiten"
                                onChange={(e) => changeHelpPayload(e.target.value, "title")}
                                value={helpPayload?.title || "Kein Titel"}
                                variant="standard"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            flex: 1,
                            width: "100%",
                            "&>.MuiGrid-root>.MuiGrid-item": {
                                padding: 5,
                            },
                        }}
                    >
                        <Grid item>
                            <PTMInput
                                type="editor"
                                value={helpPayload?.content || ""}
                                onChange={(e) => changeHelpPayload(e, "content")}
                                fullWidth
                                fullHeight
                            />
                        </Grid>
                    </Grid>
                    <FormControlLabel
                        sx={{ marginLeft: "initial" }}
                        control={(
                            <Checkbox
                                size="medium"
                                checked={helpPayload?.is_published > 0}
                                onChange={(e) => changeHelpPayload(e.target.checked === false ? -1 : 1, "is_published")}
                            />
                        )}
                        label="veröffentlicht"
                    />
                </div>
                <PTMBottomAppBar
                    buttons={
                        [
                            {
                                name: "Speichern",
                                click: sendHelpPayload,
                                icon: "save",
                                color: "success",
                                loading: saving,
                            },
                            {
                                name: "Verwerfen",
                                click: () => { resetPayload(); setEditorOpen(false); },
                                icon: "trash",
                                color: "error",
                            },
                            {
                                name: "Schließen",
                                click: handleClose,
                                icon: "times",
                                color: "primary",
                            },
                        ]
                    }
                />
            </>
        );
    }

    return (
        <PTMDialog
            open={open || isOpen}
            icon="question-circle"
            resizeable
            resizeableStyle={{ display: "flex", flexDirection: "column" }}
            initialWidth={editorOpen ? 1000 : 500}
            initialHeight={editorOpen ? 600 : 300}
            minSizes={[200, 200]}
            maxSizes={[1200, 1200]}
            disableBackdrop
            title={helpPayload?.title}
            onClose={handleClose}
            tabId={tabId}
            footerButtons={
                [
                    {
                        name: "Bearbeiten",
                        click: () => setEditorOpen(true),
                        color: "success",
                        hide: !canEdit || editorOpen,
                        icon: "cogs",
                    },
                    {
                        hide: editorOpen,
                        name: "Schließen",
                        click: handleClose,
                        color: "error",
                        icon: "times",
                    },
                ]
            }
        >

            <PTMConfirmDialog
                title="Änderungen ermittelt"
                open={confirmDiscard}
                setOpen={setConfirmDiscard}
                onConfirm={() => closeAndClean()}
            >
                Möchten Sie die Änderungen verwerfen?
            </PTMConfirmDialog>

            { !editorOpen
                && (
                    <Typography
                        sx={{
                            padding: "10px",
                        }}
                        gutterBottom
                    >
                        <div
                            dangerouslySetInnerHTML={
                                {
                                    __html: helpPayload?.content
                                        || "Im Moment hat noch niemand einen Hilfetext eingegeben. Klicken Sie zum Hinzufügen auf die Schaltfläche \"bearbeiten\".",
                                }
                            }
                        />
                    </Typography>
                )}
            {editorOpen ? (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}
                >
                    {editorScreen()}
                </div>
            ) : null}
        </PTMDialog>
    );
}

export default React.memo(HelpDialog);
